import { NgModule } from '@angular/core';

import { CONFIG_MANAGER_SERVICE_CONFIGURATION } from '@xpo-ltl/config-manager';
import { DataApiService } from '@xpo-ltl/data-api';
import { LoggedInUserResolver } from './resolvers/logged-in-user-resolver';
import { RoleCheckGuard } from './guards/role-check-guard';
import { SearchKeyResolver } from './resolvers/search-key-resolver';
import { ChipsListDropdownComponent } from './components/chips-list-dropdown/chips-list-dropdown.component';
import { MaterialModule } from './material.module';

@NgModule({
  declarations: [ChipsListDropdownComponent],
  imports: [MaterialModule],
  exports: [ChipsListDropdownComponent],
  providers: [
    { provide: CONFIG_MANAGER_SERVICE_CONFIGURATION, useValue: { configFileUrl: './assets/config.json' } },
    DataApiService,
    LoggedInUserResolver,
    RoleCheckGuard,
    SearchKeyResolver,
  ],
})
export class SharedServicesModule {
  constructor() {}
}
